import { createFileRoute } from "@tanstack/react-router";

import Audit from "~/pages/Administration/Audit";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/administration/audit")({
  staticData: ROUTE_STATIC.administration,
  component: Audit,
});
